import React from "react";
import styles from "./style.module.css";

const Modal = ({ endpoint, mockData, onClose }) => {
  const method = endpoint?.method || endpoint?.supportedMethods || "GET";

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <div className={styles.headerInfo}>
            <span className={`${styles.method} ${styles[method.toLowerCase()]}`}>
              {method}
            </span>
            <h3 className={styles.title}>{endpoint?.name || "Endpoint"}</h3>
          </div>
          <button className={styles.closeBtn} onClick={onClose}>
            ×
          </button>
        </div>

        <div className={styles.body}>
          <div className={styles.section}>
            <label>Endpoint</label>
            <code className={styles.path}>{endpoint?.path}</code>
          </div>

          {endpoint?.description && (
            <div className={styles.section}>
              <label>Description</label>
              <p className={styles.description}>{endpoint.description}</p>
            </div>
          )}

          {endpoint?.parameters && endpoint.parameters.length > 0 && (
            <div className={styles.section}>
              <label>Parameters</label>
              <div className={styles.params}>
                {endpoint.parameters.map((param, i) => (
                  <div key={i} className={styles.param}>
                    <span className={styles.paramName}>{param.name}</span>
                    <span className={styles.paramType}>{param.type}</span>
                    {param.required && <span className={styles.required}>required</span>}
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className={styles.section}>
            <label>Mock Response</label>
            <pre className={styles.response}>
              {JSON.stringify(mockData, null, 2)}
            </pre>
          </div>
        </div>

        <div className={styles.footer}>
          <button className={styles.footerBtn} onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
